import { render, staticRenderFns } from "./LpuFavouriteBtn.vue?vue&type=template&id=5935b352&"
import script from "./LpuFavouriteBtn.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuFavouriteBtn.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5935b352')) {
      api.createRecord('5935b352', component.options)
    } else {
      api.reload('5935b352', component.options)
    }
    module.hot.accept("./LpuFavouriteBtn.vue?vue&type=template&id=5935b352&", function () {
      api.rerender('5935b352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuFavouriteBtn.vue"
export default component.exports